export default __webpack_public_path__ + "static/media/1-card.a9344442.png";